import { Injectable } from '@angular/core';
import * as RouteConstants from '../constants/route.constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CountrySelectOptionModel } from '../models/country-select-option.model';
import { Observable } from 'rxjs';
import { GetAllCountriesResponse } from '../models/get-all-countries-response.model';
import { GetRegionCountriesResponse } from '../models/get-region-countries-response.model';
import { InDepthFilterOptionsModel } from '../models/mecs-models/in-depth-filter-options.model';
import { FilterRequestMecsModel } from '../models/mecs-models/filter-request-mecs.model';
import { SelectOption } from '../models/mecs-models/mecs-filter-select-options.model';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private routeConstants = RouteConstants;

  constructor(private httpClient: HttpClient) { }

  getCountryOptions(regionId: number): Observable<CountrySelectOptionModel[]>{
    let queryParams = new HttpParams();
    queryParams = queryParams.append('regionId', regionId);
    
    return this.httpClient.get<CountrySelectOptionModel[]>(this.routeConstants.GET_COUNTRY_OPTIONS_ROUTE, {params: queryParams});
  }
  
  getMecsCountryOptions(regionId: number): Observable<CountrySelectOptionModel[]>{
    let queryParams = new HttpParams();
    queryParams = queryParams.append('regionId', regionId);
    
    return this.httpClient.get<CountrySelectOptionModel[]>(this.routeConstants.GET_MECS_COUNTRY_OPTIONS_ROUTE, {params: queryParams});
  }
  
  getAllCountries(): Observable<GetAllCountriesResponse[]>{
    return this.httpClient.get<GetAllCountriesResponse[]>(this.routeConstants.GET_ALL_COUNTRIES_ROUTE);
  }
  
  getRegionCountries(): Observable<GetRegionCountriesResponse[]>{
    return this.httpClient.get<GetRegionCountriesResponse[]>(this.routeConstants.GET_REGION_COUNTRIES);
  }

  getInDepthFilterOptions(): Observable<InDepthFilterOptionsModel> { 
        return this.httpClient.get<InDepthFilterOptionsModel>(this.routeConstants.GET_IN_DEPTH_FILTER_OPTIONS);

  }

  getInDepthCoyntryList(filterRequest: FilterRequestMecsModel): Observable<SelectOption[]>{
      return this.httpClient.post<SelectOption[]>(this.routeConstants.GET_IN_DEPTH_COUNTRY_LIST, filterRequest);
  }
}
